import React, { useMemo } from "react";
import { Marker, Popup } from "react-leaflet";


const SwitchMarkerOpticMap  = React.memo(({
    coordinate,
  coordinates,
  zoomLevel,
  layersVisibility,
  showPonLayer,
  showKtvLayer,
  ktvAmplifierData,
  isLineDrawing,
  openModalNode,
  openModalNodeEnt,
  handleOpenModal,
  handleCloseModal,
  user,
  cantonRefreshNode,
  role,
  CONST_CANTON,
  cantonFobRefresh,
  cantonPonBoxRefresh,
  icon3kKtv,
  icon100pab,
  icon3k,
  iconKp,
  icon30k,
  iconSummit,
  DialogNodeDescroption
}) => {
  // дубликаты
  const duplicateCoordinates = useMemo(
    () => coordinates.filter(
      (c) => c.hid === coordinate.hid && c.entrance === coordinate.entrance
    ),
    [coordinates, coordinate.hid, coordinate.entrance]
  );

  // главный узел
  const maxRankCoordinate = useMemo(
    () => [coordinate, ...duplicateCoordinates]
      .reduce((acc, curr) => (curr.rank < acc.rank ? curr : acc), coordinate),
    [coordinate, duplicateCoordinates]
  );

  const isZoom100pab = zoomLevel > 16;
  const isZoom3k = zoomLevel > 13;

  // видимость
  const isVisible = useMemo(() => {
    return layersVisibility[
      showPonLayer || showKtvLayer ? '' :
      maxRankCoordinate.rank === 4 && isZoom100pab ? 'icon100pab' :
      maxRankCoordinate.rank === 4 ? '' :
      maxRankCoordinate.rank === 3 && isZoom3k && maxRankCoordinate.modelSw === "Контроль питания, ранг 3" ? 'iconKp' :
      maxRankCoordinate.rank === 3 && isZoom3k ? 'icon3k' :
      maxRankCoordinate.rank === 3 ? '' :
      maxRankCoordinate.rank === 2 ? 'icon30k' :
      maxRankCoordinate.rank === 1 ? 'iconSummit' : ''
    ];
  }, [layersVisibility, showPonLayer, showKtvLayer, maxRankCoordinate, isZoom100pab, isZoom3k]);

  // наличие усилителя
  const hasAmplifier = useMemo(
    () => ktvAmplifierData.some(
      (amp) =>
        amp.hid === coordinate.hid &&
        amp.entrance === coordinate.entrance &&
        amp.ktvAmplifierId != null
    ),
    [ktvAmplifierData, coordinate.hid, coordinate.entrance]
  );

  // уникальные координаты
  const filteredCoords = useMemo(
    () => [...new Map(
      [maxRankCoordinate, ...duplicateCoordinates]
        .filter((coord) => coord.ip)
        .map((coord) => [coord.ip, coord])
    ).values()],
    [maxRankCoordinate, duplicateCoordinates]
  );

  // иконка
  const markerIcon = useMemo(() => {
    if (hasAmplifier && (maxRankCoordinate.rank === 4 || (maxRankCoordinate.rank === 3 && isZoom3k))) {
      return icon3kKtv;
    }
    if (maxRankCoordinate.rank === 4) return icon100pab;
    if (maxRankCoordinate.rank === 3 && isZoom3k) {
      return maxRankCoordinate.modelSw === "Контроль питания, ранг 3" ? iconKp : icon3k;
    }
    if (maxRankCoordinate.rank === 2) return icon30k;
    if (maxRankCoordinate.rank === 1) return iconSummit;
    return null;
  }, [hasAmplifier, maxRankCoordinate, isZoom3k, icon3kKtv, icon100pab, icon3k, iconKp, icon30k, iconSummit]);

  // теперь можно вернуть null
  if (!isVisible) return null;

  return (
    <Marker
      position={[maxRankCoordinate.latitude, maxRankCoordinate.longitude]}
      icon={markerIcon}
      eventHandlers={
        !isLineDrawing
          ? { click: () => handleOpenModal(maxRankCoordinate.hid, maxRankCoordinate.entrance) }
          : {}
      }
    >
      {(openModalNode === maxRankCoordinate.hid && openModalNodeEnt === maxRankCoordinate.entrance) && (
        <DialogNodeDescroption
          openModalNode={openModalNode}
          openModalNodeEnt={openModalNodeEnt}
          handleCloseModal={handleCloseModal}
          maxRankCoordinate={maxRankCoordinate}
          filteredCoords={filteredCoords}
          user={user}
          cantonRefresh={cantonRefreshNode}
          role={role}
          flag={CONST_CANTON}
          cantonFobRefresh={cantonFobRefresh}
          cantonPonBoxRefresh={cantonPonBoxRefresh}
        />
      )}
    </Marker>
  );
});

export default SwitchMarkerOpticMap;